import { CommonModule } from '@angular/common';
import { Component, Signal, InputSignal, input, output, OutputEmitterRef, computed } from '@angular/core';
import { NumberInputComponent } from '../../../shared/components/number-input/number-input.component';
import { FinancialAdjustment, ICodWithSubtype, IOrderLine, IUser, Region } from '@cod-monorepo/interfaces';
import { select, Store } from '@ngxs/store';
import { UserState } from '../../../user-management/state/user-management.state';
import { UserPipe } from '../../../shared/pipes/user.pipe';
import { ButtonModule, TooltipModule } from '@sag-ui';
import { LoadOrderLineItems, OpenForm } from '../../state/cod.action';
import { GeneralCod } from '../../models/cod.model';
import { CodOperations } from '../../operations/cod.operations';

@Component({
    selector: 'app-cod-detail-card',
    templateUrl: './cod-detail-card.component.html',
    imports: [CommonModule, NumberInputComponent, UserPipe, ButtonModule, TooltipModule],
    standalone: true
})
export class CodDetailCardComponent<T extends { issueType: string }> {
    public data: InputSignal<ICodWithSubtype<T> & { financialAdjustmentRequest?: FinancialAdjustment }> =
        input.required();
    public expandable: InputSignal<boolean> = input(false);
    public formOpenable: InputSignal<boolean> = input(false);
    public open: InputSignal<boolean> = input(true);
    public showBackTo: InputSignal<boolean> = input(false);
    public index: InputSignal<number | undefined> = input();

    public openForm: OutputEmitterRef<void> = output<void>();

    protected user?: Signal<IUser | undefined> = select(UserState.user);
    public region = Region;
    public internalOpen = this.open();

    public orderLineItem: Signal<IOrderLine | undefined> = computed(() => this.data().affectedOrderLines?.[0]);

    public financialAdjustmentValue: Signal<number> = computed(() =>
        CodOperations.calculateFinancialAdjustmentValue(this.data() as GeneralCod)
    );

    public createdAt: Signal<Date> = computed(() => {
        if (!this.data().id) {
            return new Date();
        }

        return this.data().createdAt;
    });

    public sortedOrderLines: Signal<IOrderLine[]> = computed(
        () => this.data().affectedOrderLines?.sort((a, b) => (a.salesOrderLine ?? 0) - (b.salesOrderLine ?? 0)) || []
    );

    constructor(private store: Store) {}

    public removeLeadingZeros(value: string): string {
        return value.replace(/^0+/, '');
    }

    public backToForm(): void {
        if (this.index !== undefined) {
            this.store.dispatch(new OpenForm(this.index() ?? 0));

            const { referenceNumber, referenceNumberType } = this.data();
            this.store.dispatch(new LoadOrderLineItems(referenceNumber, referenceNumberType));
        }
    }
}
